
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/information/[slugOrId]",
      function () {
        return require("private-next-pages/information/[slugOrId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/information/[slugOrId]"])
      });
    }
  